import React from 'react';
import { Form, InputNumber, Modal, Switch } from 'antd';
import type { FormInstance } from 'antd';
import type { SyncTask } from './types';

type Props = {
  open: boolean;
  task: SyncTask | null;
  form: FormInstance;
  submitting: boolean;
  onOk: () => void;
  onCancel: () => void;
};

const SyncTaskEditModal: React.FC<Props> = ({ open, task, form, submitting, onOk, onCancel }) => (
  <Modal
    title={task ? `编辑任务 - ${task.taskName}` : '编辑任务'}
    open={open}
    onOk={onOk}
    confirmLoading={submitting}
    onCancel={onCancel}
    destroyOnClose
  >
    <Form form={form} layout="vertical">
      <Form.Item label="启用任务" name="enabled" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item label="执行频率（分钟）" name="intervalMinutes" rules={[{ required: true, message: '请输入执行频率' }]}>
        <InputNumber min={1} max={1440} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="单次批量上限" name="batchLimit" rules={[{ required: true, message: '请输入批量上限' }]}>
        <InputNumber min={1} max={500} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="回看天数" name="lookbackDays" rules={[{ required: true, message: '请输入回看天数' }]}>
        <InputNumber min={1} max={1095} style={{ width: '100%' }} />
      </Form.Item>
      {task?.taskType === 'order_auto_retry' ? (
        <Form.Item
          label="最大自动重提次数"
          name="maxRetryCount"
          tooltip="不包含首次下单提交。达到次数后订单会转为“需要手动重提”，并发送飞书提醒。"
          rules={[{ required: true, message: '请输入最大自动重提次数' }]}
        >
          <InputNumber min={0} max={20} style={{ width: '100%' }} />
        </Form.Item>
      ) : null}
    </Form>
  </Modal>
);

export default SyncTaskEditModal;
